import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://nauidvyfldzfstnxhayt.supabase.co"
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYzMjE1MjYyNywiZXhwIjoxOTQ3NzI4NjI3fQ.kr7nVpXwZoafrYbesxnhO5SnF9aGtZyGzrWq7DY5vDc"

export const supabase = createClient(supabaseUrl, supabaseKey)